import { render, staticRenderFns } from "./ErrorsCell.vue?vue&type=template&id=1b621923&scoped=true"
import script from "./ErrorsCell.vue?vue&type=script&lang=js"
export * from "./ErrorsCell.vue?vue&type=script&lang=js"
import style0 from "./ErrorsCell.vue?vue&type=style&index=0&id=1b621923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b621923",
  null
  
)

export default component.exports